import { Injectable } from '@angular/core';
import { MCSGDSModel } from './mcs-gds.model';
import { ConfigurationTemplate } from '../wizard-model.interface';

@Injectable()
export class GDSModel extends MCSGDSModel {
  public readonly type = "GDS";

  protected createConfig(): ConfigurationTemplate {
    return {
      id: "create-project-gds",
      type: 'type',
      imageUrl: `ng-assets/img/projecttypes/gds-article.webp`,
      label: `configurationCreation.type.gds`,
      steps: [
        {
          type: "meta",
          id: "meta",
          label: "configurationCreation.progress.configuration_data",
        },
        {
          type: "mcsGds",
          id: 'gds',
          label: 'configurationCreation.progress.select_article',
          articleType: 'GDS',
        }
      ]
    }
  }
}
